/**
 * Helpers for turning an api-hub error into something a learner can read.
 */

export const GENERIC_API_ERROR = 'Something went wrong. Please try again.';

/**
 * Digs the learner-facing sentence out of an api-hub error. A SignupError arrives as JSON
 * nested one or two levels inside errorMessage/message.
 * @param {Error} error - the rejection, which may not be an axios error at all
 * @param {string} fallback - copy to show when nothing usable is found
 * @returns {string}
 */
export function extractApiMessage(error, fallback = GENERIC_API_ERROR) {
  const payload = error?.response?.data || {};
  let message = payload.errorMessage || payload.message || error?.message || '';

  for (let depth = 0; depth < 2; depth++) {
    try {
      const parsed = JSON.parse(message);

      message = parsed.message || parsed.errorMessage || message;
    } catch {
      break;
    }
  }

  return message || fallback;
}
